<template>
  <v-dialog max-width="500" persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title class="headline">{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="close()">close</v-icon>
      </v-toolbar>

      <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex v-if="editedIndex !== 2">
              <v-select
                v-model="form.bank_name_id"
                :disabled="fetching_data"
                :loading="fetching_data"
                :items="bank_list"
                item-text="thbk_name_th"
                item-value="id"
                label="Bank name"
                hide-details
              ></v-select>
              <v-text-field v-model="form.bank_account_name" label="Account name" hide-details></v-text-field>
              <v-text-field v-model="form.bank_account_number" label="Account number" hide-details></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="adding_editing || isEditRiderSetting"
          :loading="adding_editing"
          color="primary"
          class="black--text"
          v-if="editedIndex === -1"
          @click="save()"
        >add</v-btn>
        <v-btn
          :disabled="adding_editing || isEditRiderSetting"
          :loading="adding_editing"
          color="primary"
          class="black--text"
          v-if="editedIndex === 1"
          @click="edit()"
        >update</v-btn>
        <v-spacer />

        <label v-if="editedIndex == -1">{{ check_success == 3 ? 'Cant add' : ''}}</label>
        <label v-else>{{ check_success == 3 ? 'Cant edit' : ''}}</label>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["dialog", "editedIndex", "select_item"],
  data() {
    return {
      check_success: 0,
      original_data: {},
      adding_editing: false,
      form: {},
      fetching_data: false,
      valid: true,
      img: require("@/assets/back-office/banana.jpg")
    };
  },
  computed: {
    ...mapState({
      bank_list: state => state.fetchWeserveBank.bank_list
    }),
    ...mapGetters(["isEditRiderSetting"]),
    formTitle() {
      return this.editedIndex === -1
        ? "Add bank account"
        : this.editedIndex === 1
        ? "Edit bank account"
        : "Bank account detail";
    }
  },
  watch: {
    async dialog() {
      if (this.dialog == true) {
        if (this.editedIndex == -1) {
          this.form = {};
        } else {
          this.form = this.select_item;
          this.original_data = JSON.parse(JSON.stringify(this.form));
        }
        this.fetching_data = true;
        await this.$store.dispatch("fetchWeserveBank/getBankList");
        this.fetching_data = false;
      }
    }
  },
  methods: {
    async edit() {
      let obj_clone = JSON.parse(JSON.stringify(this.form));
      obj_clone = await this.$store.dispatch("splitTemp", obj_clone);
      this.adding_editing = true;
      this.check_success = await this.$store.dispatch(
        "fetchWeserveBank/editBankAccount",
        obj_clone
      );
      this.adding_editing = false;
      if (this.check_success == 2) {
        this.$emit("setDialog", false);
        this.$emit("setEditIndex", -1);
      }
    },
    async save() {
      this.adding_editing = true;
      this.check_success = await this.$store.dispatch(
        "fetchWeserveBank/addBankAccount",
        this.form
      );
      this.adding_editing = false;
      if (this.check_success == 2) {
        this.$emit("setDialog", false);
        this.$emit("setEditIndex", -1);
      }
    },
    close() {
      if (!this.adding_editing) {
        if (this.editedIndex != -1) {
          Object.assign(this.form, this.original_data);
        }
        this.$emit("setDialog", false);
        this.$emit("setEditIndex", -1);
      }
    }
  }
};
</script>

<style scoped>
.style-title-detail {
  font-size: 15px;
  margin-bottom: 10px;
}

.style-data-detail {
  font-size: 15px;
  color: #616a6b;
}
</style>




